import { render, staticRenderFns } from "./groupConversationItem.vue?vue&type=template&id=c5134c62&scoped=true&"
import script from "./groupConversationItem.vue?vue&type=script&lang=js&"
export * from "./groupConversationItem.vue?vue&type=script&lang=js&"
import style0 from "./groupConversationItem.vue?vue&type=style&index=0&id=c5134c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5134c62",
  null
  
)

export default component.exports